import { createContext, useContext, useState, useCallback } from 'react';
import { useLanguage } from './preferenceProvider';
import '../css/toast.css';

const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);
  const [loading, setLoading] = useState(false);
  const { t } = useLanguage();

  const showToast = useCallback((message, type = 'info', duration = 5000) => {
    const id = Math.random();
    setToasts((prev) => [...prev, { id, message, type }]);
    setTimeout(() => {
      setToasts((prev) => prev.filter((toast) => toast.id !== id));
    }, duration);
  }, []);

  const showActionToast = useCallback((text, onConfirm, children = null) => {
    const id = Math.random();
    setToasts((prev) => [
      ...prev,
      {
        id,
        type: 'action',
        render: (close) =>
          <div className="action">
            <div>
              <span>{text}</span>
            </div>
            {typeof children === "function" ? children(close) : children ? children : (
              <div className="action-content">
                <button className="cancel" onClick={close}>{t.close}</button>
                <button className="confirm" onClick={() => { close(); onConfirm && onConfirm(); }}>{t.confirm}</button>
              </div>
            )}
          </div>
      },
    ]);
  }, []);

  const hideToast = useCallback((id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  }, []);

  const showLoading = useCallback(() => setLoading(true), []);
  const hideLoading = useCallback(() => setLoading(false), []);
  
  const hasActionToast = toasts.some((toast) => toast.type === 'action');

  return (
    <ToastContext.Provider value={{ showToast, showActionToast, hideToast, showLoading, hideLoading, loading }}>
      {children}
      {hasActionToast && (
        <div className="toast-modal-overlay"></div>
      )}
      <div className="toast-container">
        {toasts.map((toast) => (
          <div key={toast.id} className={`toast ${toast.type}`}>
            {toast.render
              ? toast.render(() => hideToast(toast.id))
              : (
                <>
                  <span>{toast.message}</span>
                  <button className="toast-close-button" onClick={() => hideToast(toast.id)}>&times;</button>
                </>
              )
            }
          </div>
        ))}
      </div>
      {loading && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
        </div>
      )}
    </ToastContext.Provider>
  );
};